export const WORKSPACE_CAPABILITIES = {
    STATS: 'workspace.stats',
    TICKETS: 'workspace.tickets',
    PROJECTS: 'workspace.projects',
    RELATIONSHIPS: 'workspace.relationships',
    BOARDS: 'workspace.boards',
    POSITIONS: 'workspace.positions',
    FINANCE: 'workspace.finance',
    FILE_MANAGER: 'workspace.file_manager',
    DOCUMENTATION: 'workspace.documentation',
    VAULT: 'workspace.vault',
    SERVER_MONITORING: 'workspace.server_monitoring',
    CANNED_REPLIES: 'workspace.canned_replies',
    ADMIN_TICKET_TOPICS: 'workspace.admin.ticket_topics',
    ADMIN_LABELS: 'workspace.admin.labels',
    ADMIN_LEGAL_LINKS: 'workspace.admin.legal_links',
    ADMIN_LANGUAGES: 'workspace.admin.languages',
    ADMIN_BILLINGS: 'workspace.admin.billings',
    ADMIN_COMPANIES: 'workspace.admin.companies',
    ADMIN_CMS_ASSETS: 'workspace.admin.cms.assets',
    ADMIN_CMS_DOMAINS: 'workspace.admin.cms.domains',
    ADMIN_CMS_LANGUAGES: 'workspace.admin.cms.languages',
    ADMIN_CMS_PAGES: 'workspace.admin.cms.pages',
    ADMIN_CMS_TEMPLATES: 'workspace.admin.cms.templates',
    ADMIN_PRIORITIES: 'workspace.admin.priorities',
    ADMIN_PROCESS_STEPS: 'workspace.admin.process_steps',
    ADMIN_SERVICE_CATEGORIES: 'workspace.admin.service_categories',
    ADMIN_SETTINGS: 'workspace.admin.settings',
    ADMIN_STATUSES: 'workspace.admin.statuses',
    ADMIN_USERS: 'workspace.admin.users',
    ADMIN_USER_ROLES: 'workspace.admin.user_roles',
};

export const WORKSPACE_CMS_CAPABILITIES = [
    WORKSPACE_CAPABILITIES.ADMIN_CMS_ASSETS,
    WORKSPACE_CAPABILITIES.ADMIN_CMS_DOMAINS,
    WORKSPACE_CAPABILITIES.ADMIN_CMS_LANGUAGES,
    WORKSPACE_CAPABILITIES.ADMIN_CMS_PAGES,
    WORKSPACE_CAPABILITIES.ADMIN_CMS_TEMPLATES,
];

const LEGACY_CONTROLLER_CAPABILITY_MAP = {
    'App.Http.Controllers.Api.Workspace.StatsController': WORKSPACE_CAPABILITIES.STATS,
    'App.Http.Controllers.Api.Workspace.TicketController': WORKSPACE_CAPABILITIES.TICKETS,
    'App.Http.Controllers.Api.Workspace.ProjectController': WORKSPACE_CAPABILITIES.PROJECTS,
    'App.Http.Controllers.Api.Workspace.RelationshipController': WORKSPACE_CAPABILITIES.RELATIONSHIPS,
    'App.Http.Controllers.Api.Workspace.BoardController': WORKSPACE_CAPABILITIES.BOARDS,
    'App.Http.Controllers.Api.Workspace.PositionController': WORKSPACE_CAPABILITIES.POSITIONS,
    'App.Http.Controllers.Api.Workspace.FinanceController': WORKSPACE_CAPABILITIES.FINANCE,
    'App.Http.Controllers.Api.Workspace.FileManagerController': WORKSPACE_CAPABILITIES.FILE_MANAGER,
    'App.Http.Controllers.Api.Workspace.DocumentationController': WORKSPACE_CAPABILITIES.DOCUMENTATION,
    'App.Http.Controllers.Api.Workspace.VaultController': WORKSPACE_CAPABILITIES.VAULT,
    'App.Http.Controllers.Api.Workspace.ServerMonitoringController': WORKSPACE_CAPABILITIES.SERVER_MONITORING,
    'App.Http.Controllers.Api.Workspace.CannedReplyController': WORKSPACE_CAPABILITIES.CANNED_REPLIES,
    'App.Http.Controllers.Api.Workspace.Admin.TicketTopicController': WORKSPACE_CAPABILITIES.ADMIN_TICKET_TOPICS,
    'App.Http.Controllers.Api.Workspace.Admin.LabelController': WORKSPACE_CAPABILITIES.ADMIN_LABELS,
    'App.Http.Controllers.Api.Workspace.Admin.LegalLinkController': WORKSPACE_CAPABILITIES.ADMIN_LEGAL_LINKS,
    'App.Http.Controllers.Api.Workspace.Admin.LanguageController': WORKSPACE_CAPABILITIES.ADMIN_LANGUAGES,
    'App.Http.Controllers.Api.Workspace.Admin.BillingController': WORKSPACE_CAPABILITIES.ADMIN_BILLINGS,
    'App.Http.Controllers.Api.Workspace.Admin.CompanyController': WORKSPACE_CAPABILITIES.ADMIN_COMPANIES,
    'App.Http.Controllers.Api.Workspace.Admin.ServiceAccountController': WORKSPACE_CAPABILITIES.ADMIN_COMPANIES,
    'App.Http.Controllers.Api.Workspace.Admin.CmsAssetController': WORKSPACE_CAPABILITIES.ADMIN_CMS_ASSETS,
    'App.Http.Controllers.Api.Workspace.Admin.CmsFileManagerController': WORKSPACE_CAPABILITIES.ADMIN_CMS_ASSETS,
    'App.Http.Controllers.Api.Workspace.Admin.CmsDomainController': WORKSPACE_CAPABILITIES.ADMIN_CMS_DOMAINS,
    'App.Http.Controllers.Api.Workspace.Admin.CmsLanguageController': WORKSPACE_CAPABILITIES.ADMIN_CMS_LANGUAGES,
    'App.Http.Controllers.Api.Workspace.Admin.CmsCustomFieldLibraryController': WORKSPACE_CAPABILITIES.ADMIN_CMS_TEMPLATES,
    'App.Http.Controllers.Api.Workspace.Admin.CmsModuleController': WORKSPACE_CAPABILITIES.ADMIN_CMS_TEMPLATES,
    'App.Http.Controllers.Api.Workspace.Admin.CmsModuleTypeController': WORKSPACE_CAPABILITIES.ADMIN_CMS_TEMPLATES,
    'App.Http.Controllers.Api.Workspace.Admin.CmsPageController': WORKSPACE_CAPABILITIES.ADMIN_CMS_PAGES,
    'App.Http.Controllers.Api.Workspace.Admin.CmsSlotController': WORKSPACE_CAPABILITIES.ADMIN_CMS_TEMPLATES,
    'App.Http.Controllers.Api.Workspace.Admin.CmsTemplateController': WORKSPACE_CAPABILITIES.ADMIN_CMS_TEMPLATES,
    'App.Http.Controllers.Api.Workspace.Admin.PriorityController': WORKSPACE_CAPABILITIES.ADMIN_PRIORITIES,
    'App.Http.Controllers.Api.Workspace.Admin.ProcessStepController': WORKSPACE_CAPABILITIES.ADMIN_PROCESS_STEPS,
    'App.Http.Controllers.Api.Workspace.Admin.ServiceCategoryController': WORKSPACE_CAPABILITIES.ADMIN_SERVICE_CATEGORIES,
    'App.Http.Controllers.Api.Workspace.Admin.SettingController': WORKSPACE_CAPABILITIES.ADMIN_SETTINGS,
    'App.Http.Controllers.Api.Workspace.Admin.StatusController': WORKSPACE_CAPABILITIES.ADMIN_STATUSES,
    'App.Http.Controllers.Api.Workspace.Admin.UserController': WORKSPACE_CAPABILITIES.ADMIN_USERS,
    'App.Http.Controllers.Api.Workspace.Admin.UserRoleController': WORKSPACE_CAPABILITIES.ADMIN_USER_ROLES,
};

function normalizeControllerKey(key) {
    const value = String(key || '').trim();
    if (value === '') {
        return null;
    }

    return value.replace(/\\/g, '.');
}

export function normalizeCapabilityKey(permissionKey) {
    const normalizedKey = String(permissionKey || '').trim();
    if (normalizedKey === '') {
        return null;
    }

    if (Object.values(WORKSPACE_CAPABILITIES).includes(normalizedKey)) {
        return normalizedKey;
    }

    const controllerKey = normalizeControllerKey(normalizedKey);
    return controllerKey ? (LEGACY_CONTROLLER_CAPABILITY_MAP[controllerKey] || null) : null;
}

export function normalizeCapabilityMap(rawPermissions = {}) {
    const source = rawPermissions && typeof rawPermissions === 'object' && !Array.isArray(rawPermissions)
        ? rawPermissions
        : {};

    return Object.keys(source).reduce((capabilities, key) => {
        const capabilityKey = normalizeCapabilityKey(key);
        if (capabilityKey) {
            capabilities[capabilityKey] = !!source[key];
        }

        return capabilities;
    }, {});
}
